<template>
    <div>
        <div style="width: 100%;display:flex;">
            <div style="width: 70%;">
                <div>
                    <Input search enter-button placeholder="请搜索" @on-search="keyword = $event" />
                </div>
                <div style="height:400px;overflow: auto;width: 100%">
                    <CheckboxGroup class="checkbox" v-model="newColumn" style="display:flex;flex-wrap: wrap;">
                        <div v-for="item in orgin.filter(i => i.title&&i.title.includes(keyword))" :key="item.key">
                            <Checkbox :disabled="!!item.always"
                                style="width: 100%;border: none;margin:0;padding:0;font-size: 15px" :label="item.key"
                                border>{{ item.title }}</Checkbox>
                        </div>
                    </CheckboxGroup>
                </div>
            </div>
            <Divider type="vertical" style="height:auto" />
            <div style="width: 30%;">
                <div style="display: flex;padding:10px;font-size:16px;justify-content: space-between;">
                    <span>已添加({{ newColumn.length }})</span>
                    <div>
                        <span style="color:#2d8cf0;cursor:pointer;" @click="handleSelectAll">全选</span>
                        <!-- <span style="color:#2d8cf0;cursor:pointer;margin-left: 10px;"
                                                @click="handleResetColumn">重置</span> -->
                    </div>
                </div>
                <div style="height: 400px;overflow:auto;">
                    <draggable v-model="newColumn" :options="{ animation: 150 }" @start="dragStart" @end="dragEnd">
                        <TransitionGroup>
                            <div style="margin-bottom: 10px;"
                                v-for="(item, index) in newColumn.map(i => orgin.find(j => j.key == i))" :key="index">
                                <div :draggable="false"
                                    style="margin-bottom: 10px;padding: 5px 10px;background:#f8f8f9;border-radius: 5px;font-size: 14px;display:flex;align-items: center;">
                                    <Icon v-if="item && !item.always" type="md-reorder" :size="20" />
                                    <Icon v-else type="ios-lock-outline" :size="18" />
                                    <span style="margin-left: 10px;">{{ item && item.title }}</span>
                                    <div
                                        style="display:flex;align-items:center;flex-grow: 1;justify-content: flex-end;">
                                        <Icon type="md-close" :size="20" style="cursor: pointer;"
                                            v-if="item && !item.always"
                                            @click="newColumn = newColumn.filter(i => i != item.key)" />
                                    </div>
                                </div>
                            </div>
                        </TransitionGroup>
                    </draggable>

                </div>
            </div>
        </div>
        <Divider style="margin: 0px" />
        <div style="text-align: right;margin-top: 10px;">
            <Button @click="$emit('upload:visible',false)">取消</Button>
            <Button @click="submitColumn" style="margin-left: 10px;" type="primary">保存</Button>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
    components: {
        draggable
    },
    props: {
        column: {
            type: Array,
            default: () => []
        },
        orgin: {
            type: Array,
            default: () => []
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    model: {
        prop: 'column',
        event: 'upload:column'
    },
    data() {
        return {
            keyword: '',
            tempColumn: [],
            newColumn: []
        }
    },
    watch: {
        column: {
            handler() {
                this.newColumn = this.column
            },
            immediate: true
        }
    },
    methods: {
        handleResetColumn() {
            this.newColumn = this.orgin.filter(i => i.always).map(i => i.key)
        },
        dragStart() {
            this.tempColumn = [...this.newColumn]
        },
        dragEnd(row) {
            const indexli = this.orgin.filter(i => i.always).map((i, index) => index)
            if (indexli.includes(row.newIndex) || indexli.includes(row.oldIndex)) this.newColumn = [...this.tempColumn]
        },
        submitColumn() {
            this.$emit('upload:column',this.newColumn)
            this.$emit('upload:visible',false)
        },
        handleSelectAll() {
            
            this.newColumn = [...this.newColumn, ...this.orgin.filter(i => !this.newColumn.includes(i.key)).map(i => i.key)]
        },
    }
}
</script>

<style lang="less" scoped>
.checkbox {
    margin: 0 -10px;
    overflow: hidden;
    width: 100%;

    &>* {
        width: 50%;
        flex: 0 50%;
        padding: 5px 10px;
        font-size: 16px;
    }
}
</style>